import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Departement } from 'src/app/shared/models/departement';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class DepartementService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllDepartement(): Observable<Departement[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.departementUrl}/all`,
			'getAllDepartement'
		);
	}

	importDepartement(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'departement.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.departementUrl}/import`,
			`importDepartement`,
			formData
		);
	}

	getDepartementById(id: number): Observable<Departement> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.departementUrl}/get/${id}`,
			'getDepartementById'
		);
	}

	updateDepartement(departement: Departement): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.departementUrl}/update/${departement.id}`,
			'updateDepartement',
			departement
		);
	}

	addDepartement(departement: Departement): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.departementUrl}/add`,
			'addDepartement',
			departement
		);
	}

	deleteDepartement(departementId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.departementUrl}/delete/${departementId}`,
			`deleteDepartement`
		);
	}
}
